module.exports = {
  language: {
    name: 'English'
  },
  navbar: {
    jtgk: [
      {
        gsimg: require('../../../static/img/fesco.png'),
        biaoti: 'FESCO',
        wenzi: '北京外企人力资源服务有限公司（FESCO）成立于1979年，是开创中国人力资源服务行业的第一家企业，在业界最具竞争力和品牌价值，荣膺中国500强企业。FESCO拥有专业化的人力资源服务体系、丰富的市场经验以及完备的业务资质，是国内首家为外商驻华代表机构、外商金融机构、经济组织提供专业化人力资源服务的公司。',
        path: '/jtgk?page=1&fesco=0#aboat',
        gd: '查看更多'
      },
      {
        gsimg: require('../../../static/img/lhyw.png'),
        biaoti: '联合医务',
        wenzi: ' 香港周大福旗下企业，香港主板上市公司（HK00722）联合医务集团有限公司 (UMP) 由多位资深医生管理，并由专业医护团队参与日常运营，致力于通过旗下诊所网络为不同社区提供多元化的医疗保健服务。',
        path: '/jtgk?page=1&fesco=1#aboat',
        gd: '查看更多'
      },
      {
        gsimg: require('../../../static/img/twps.png'),
        biaoti: '台湾磐石',
        wenzi: '磐石金控集团从2003年成立以来，以六个阶段的成长计划，展开全球化布局战略，两岸实力雄厚的战略伙伴及股东群不断投入丰富的在地资源。在专业上，磐石保经破业界纪录，9次蝉联保险业奥斯卡奖之称的保险信望爱「最佳保险专业奖」，赢得业界一致肯定。经过多年努力，在两岸三地搭起一个华人理财平台，让专业人才以IFA（独立财务顾问）型态在平台上，为有理财需求的客户提供高品质服务。',
        path: '/jtgk?page=1&fesco=2#aboat',
        gd: '查看更多'
      },
      {
        gsimg: require('../../../static/img/other.png'),
        biaoti: '其他股东',
        wenzi: '',
        gd: '查看更多'
      }
    ],
    gudong: [
      {
        gd_name: 'FESCO公司',
        gd_name1: 'ABOUT FESCO',
        gd_js1: '北京外企人力资源服务有限公司（FESCO）成立于1979年，是开创中国人力资源服务行业的第一家企业，在业界最具竞争力和品牌价值，荣膺中国500强企业。',
        gd_js2: 'FESCO拥有专业化的人力资源服务体系、丰富的市场经验以及完备的业务资质，是国内首家为外商驻华代表机构、外商金融机构、经济组织提供专业化人力资源服务的公司。',
        gd_js3: 'FESCO人力资源服务体系依托网站、呼叫中心等技术手段，涵盖招聘、劳务派遣、员工福利外包、IT人员外包、财务外包、外籍人员服务等多重领域，在全国建立了190余家投资公司及分公司，服务于近3万家中外企业客户，近200万国际化人才，覆盖全国31个省市自治区400余座城市的服务网络，通过“一地签约，全国服务”为客户提供最大便捷。客户包括众多国际知名跨国企业、外资企业、国营企业、民营企业，横跨通讯、电子、IT、汽车、石化、医药、金融、快速消费品等多个行业。FESCO通过搭建以先进IT技术为基础，专业服务团队为核心，有效整合、管理各类资源的共享服务平台，提供全方位人力资源解决方案，成为客户坚实的合作伙伴。',
        gd_img: require('../../../static/img/jtgk_fesco_bg.png'),
        id: 'fesco'
      },
      {
        gd_name: '联合医务',
        gd_name1: 'ABOUT LIAN HE YI WU',
        gd_js1: '香港周大福旗下企业，香港主板上市公司（HK00722）联合医务集团有限公司 (UMP) 由多位资深医生管理，并由专业医护团队参与日常运营，致力于通过旗下诊所网络为不同社区提供多元化的医疗保健服务。',
        gd_js2: ' 除了服务广大市民外，同时为香港、澳门及中国内地各类企业与机构提供医疗保健计划。 自九十年代后期，诊所网络已从香港扩展至澳门，近年于北京、上海、广州、深圳设立了医疗中心。',
        gd_js3: '目前已服务超过3,000家企业，累积逾1,000,000名会员。联合医务于香港、澳门及中国大陆设有600多个网络服务点，其中超过40个为自设的医疗中心。',
        gd_img: require('../../../static/img/jtgk_lhyw_bg.png'),
        id: 'lhyw'
      },
      {
        gd_name: '台湾磐石',
        gd_name1: 'ABOUT TAI WAN PAN SHI',
        gd_js1: ' 磐石金控集团从2003年成立以来，以六个阶段的成长计划，展开全球化布局战略，两岸实力雄厚的战略伙伴及股东群不断投入丰富的在地资源。',
        gd_js2: '在专业上，磐石保经破业界纪录，9次蝉联保险业奥斯卡奖之称的保险信望爱「最佳保险专业奖」，赢得业界一致肯定。经过多年努力，',
        gd_js3: '在两岸三地搭起一个华人理财平台，让专业人才以IFA（独立财务顾问）型态在平台上，为有理财需求的客户提供高品质服务。',
        gd_img: require('../../../static/img/jtgk_twps_bg.png'),
        id: 'twps'
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/zh.js